<div class="fluid grid">
  <div class="field col-10">
    <label for="DC3">{{docDelvConds}}</label>
    <input id="DC3" type="text" pInputText [(ngModel)]="document.DOCDLVBASE" required value="document.DOCDLVBASE"/>
  </div>
  <div class="field col-2">
    <label for="DC4">{{docDelvTerms}}</label>
    <input id="DC4" type="number" pInputText [(ngModel)]="document.DOCDLVTERM" required value="document.DOCDLVTERM" min="0" step="1" />
  </div>
  <div class="field col-12">
    <label for="DN1">{{docNoteText1}}</label>
    <input id="DN1" type="text" pInputText [(ngModel)]="document.DOCNOTE1" value="document.DOCNOTE1"/>
  </div>
  <div class="field col-12">
    <label for="DN2">{{docNoteText2}}</label>
    <input id="DN2" type="text" pInputText [(ngModel)]="document.DOCNOTE2" value="document.DOCNOTE2"/>
  </div>
</div>
